module.exports = __webpack_public_path__ + "static/img/2.3ea10bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/fiveG/app/2.png
// module id = bVGR
// module chunks = 1